module.exports = __webpack_public_path__ + "img/pr-13.a45cc375.png";